import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Loader from './ui/Loader';

export default function FeatureTable({ features, plans }) {
	const countIncludedFeatures = (number) => number + 1;

	const getFeatureTableCol = (plan, feature) => {
		const classes = ['prc-feature-table__content'];
		feature.highlight && classes.push('prc-feature-table__content--high');

		if (typeof feature.content === 'boolean') {
			return <li key={plan} data-check={feature.content ? '+' : '-'} className={classes.join(' ')} />;
		} else {
			return <li key={plan} data-check="" className={classes.join(' ')} dangerouslySetInnerHTML={{ __html: feature.content }} />;
		}
	};

	const getFeatureTableGroup = (groups, plan = '') => {
		return Object.keys(groups).map((i) => {
			const min_features = Array();
			const max_features = features[i].features.length;
			const group = groups[i];
			const cols = !plan ? group.cols : group.cols[plan];

			if (plan && !min_features[plan]) {
				min_features[plan] = 0;
			}

			const f_cols = Object.entries(group.features).map(([i, feature]) => {
				let count = true;
				if (plan in feature['cols'] && 'count' in feature['cols'][plan]) {
					count = feature['cols'][plan]['count'];
				}

				if ((plan && count) || (plan in feature['cols'] && !('count' in feature['cols'][plan]))) {
					min_features[plan] = feature.cols[plan].content ? countIncludedFeatures(min_features[plan]) : min_features[plan];
				}

				return (
					<ul key={i} className="prc-feature-table__item">
						<li key="feature_name" className="prc-feature-table__name" dangerouslySetInnerHTML={{ __html: feature.name }} />
						{plan
							? getFeatureTableCol(plan, feature.cols[plan])
							: Object.keys(feature.cols).map((i) => {
									if (!min_features[i]) {
										min_features[i] = 0;
									}

									if ('count' in feature.cols[i]) {
										count = feature.cols[i]['count'];
									}

									if (count) {
										min_features[i] = feature.cols[i].content ? countIncludedFeatures(min_features[i]) : min_features[i];
									}

									return getFeatureTableCol(i, feature.cols[i]);
								})}
					</ul>
				);
			});

			return (
				<div key={i} className="prc-feature-table__group">
					<ul className="prc-feature-table__item prc-feature-table__item--head">
						<li key="name" className="prc-feature-table__name" dangerouslySetInnerHTML={{ __html: !group.hide ? group.name : '' }} />
						{plan
							? getFeatureTableCol(plan, { content: `${min_features[plan]} / ${max_features}` })
							: Object.keys(cols).map((i) => {
									const content = cols[i];
									content['content'] = `${min_features[i]} / ${max_features}`;
									return getFeatureTableCol(i, content);
								})}
					</ul>
					{f_cols}
				</div>
			);
		});
	};

	const getFeatureTableHead = (plan) => {
		const classes = ['prc-feature-table__content'];
		plan.most_popular && classes.push('prc-feature-table__content--high');

		return (
			<li key={plan.name} className={classes.join(' ')} data-color-scheme={plan.most_popular ? 'highlight' : ''}>
				<h4>{plan.name}</h4>
				<hr className="separator-length--short" />
			</li>
		);
	};

	const getFeatureTableStructure = (device) => {
		if (device === 'mobile') {
			return Object.keys(plans).map((i) => (
				<React.Fragment key={`plan_${i}`}>
					<ul key="head" className="prc-feature-table__item prc-feature-table__item--plans">
						{getFeatureTableHead(plans[i])}
					</ul>
					{getFeatureTableGroup(features, i)}
				</React.Fragment>
			));
		} else {
			return (
				<>
					<ul key="head" className="prc-feature-table__item prc-feature-table__item--plans">
						<li key="name"></li>
						{Object.values(plans).map((plan) => {
							return getFeatureTableHead(plan);
						})}
					</ul>
					{getFeatureTableGroup(features)}
				</>
			);
		}
	};

	const getFeatureTable = () => {
		return ['mobile', 'desktop'].map((device) => (
			<div key={device} className={`prc-feature-table prc-feature-table--${device}`}>
				{getFeatureTableStructure(device)}
			</div>
		));
	};

	const domNode = document.getElementById('pricing-features');
	if (domNode) {
		const children = !features || !plans ? <Loader /> : getFeatureTable();
		return ReactDOM.createPortal(children, domNode);
	} else {
		return null;
	}
}

FeatureTable.propTypes = {
	features: PropTypes.object,
	plans: PropTypes.object,
};
